<template>
  <button
    type="button"
    :class="[
      'btn-base',
      buttonStyle,
      isSmall ? 'small-btn' : buttonSize,
      isDisabled ? 'disable' : '',
      kclass
    ]"
    @click="onClick"
    :disabled="isDisabled"
  >
    <div class="btn-text" v-if="!loading" v-html="text">
    </div>
    <div class="spinner" v-else>
      <Spinner />
    </div>
  </button>
</template>

<script>
import Spinner from 'src/components/common/Spinner.vue'
export default {
  props: {
    onClick: {
      type: Function,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isPrimary: {
      type: Boolean,
      default: false,
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Save',
    },
    buttonSize: {
      type: String,
      default: 'button-default-size',
    },
    kclass: {
      type: String,
      default: '',
    },
  },
  components: { Spinner },
  computed: {
    buttonStyle() {
      if (this.isPrimary) return 'primary-btn'
      if (this.isDialog) return 'dialog-btn'
      return 'secondary-btn'
    },
  },
}
</script>

<style lang="scss" scoped>
.desktop-only {
  display: inline-block !important;
}
.mobile-only {
  display: none !important;
}
@media screen and (max-width: 768px) {
  .desktop-only {
    display: none !important;
  }
  .mobile-only {
    display: inline-block !important;
  }
}

.btn-base {
  border-radius: 200px;
  border: none;
  min-height: 48px;

  .btn-text {
    font-family: Inter;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.002em;
  }

  .spinner {
    display: inline-block;
  }
}

.small-btn {
  height: 40px;
  min-width: calc(min(104px, 95vw));
  display: inline-block;
  padding: 0 20px;

  .btn-text {
    font-size: 14px;
    line-height: 20px;
  }
}

.primary-btn {
  background: #ffffff;
  border: 1px solid #dda5d1;

  &:hover {
    background: rgba(255, 239, 247, 0.7);
  }

  .btn-text {
    color: #a95597;
  }
}

.secondary-btn {
  background: #171717;

  &:hover {
    background: #6d6d6d;
  }

  .btn-text {
    color: white;
  }
}

.dialog-btn {
  background: #ffffff;
  border: 1px solid #c5c5c5;

  &:hover {
    background: #f5f7f6;
  }

  .btn-text {
    color: #929292;
  }
}

.button-default-size {
  width: calc(min(314px, 90vw));
}

.btn-base:focus {
  outline: none;
}

.disable {
  background: #ffffff;
  border: 1px solid #c5c5c5;
  cursor: not-allowed;

  &:hover {
    background: #ffffff;
  }

  .btn-text {
    color: #c5c5c5;
  }
}
</style>
